import create from "zustand";

interface ModalState {
  opened: boolean;
  isClosable: boolean;
  setIsClosable: (state: boolean) => void;
  openModal: () => void;
  closeModal: () => void;
}

export const useModalStore = create<ModalState>()((set) => ({
  opened: false,
  isClosable: true,
  openModal: () => set({ opened: true }),
  closeModal: () => set({ opened: false }),
  setIsClosable: (state) => set({ isClosable: state }),
}));

export const closeModal = () => useModalStore.getState().closeModal;
export const openModal = () => useModalStore.getState().openModal;
export const modalisOpen = () => useModalStore.getState().opened;
export const setIsClosable = (state: boolean) =>
  useModalStore.setState({ isClosable: state });

export default useModalStore;
